import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import { TextArea } from 'devextreme-react';
import SelectBox from "../../../../common/CustomSelectBox";
import CheckBox from 'devextreme-react/check-box';
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/selectors";

function ResidentCardForm(props){
const {onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const zoneTypes=["Madrid","Barcelona","Otros"];

useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))
    if(types && types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
    }
},[])

useEffect(()=>{
    if(types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
    }
},[types])


function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)  
}

    return(
        <div id="documentation-request-form" style={{display: "flex", flexDirection: "column", rowGap: "1rem"}}>
                    <TextBox label="Dirección" labelMode="floating" key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)}  ></TextBox>
                <div className="grid-two-columns">
                        <TextBox label="Nome" labelMode="floating" key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)}  ></TextBox>
                        <TextBox label="Apellidos" labelMode="floating" key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)}  ></TextBox>
                </div>
                <div className="grid-two-columns"> 
                        <TextBox label="DNI" labelMode="floating" key={"dni"} name="dni" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)}  ></TextBox>
                        <TextBox label="Correo electrónico" labelMode="floating" key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)}  ></TextBox>
                </div>
                <div className="grid-two-columns">
                    <div className="template-checkbox-container">
                        <CheckBox key={"mtr"} name="mtr" value={dataForm?.mtr? dataForm.mtr : false} onValueChanged={(e) => onChange("mtr", e.value)} style={{marginTop: 0}}></CheckBox>
                        <label>MTR</label>
                    </div>
                        <SelectBox label="Zona" labelMode="floating" value={dataForm?.zone} onValueChanged={(e) => onChange("zone",e.value)} placeholder="" dataSource={zoneTypes} showClearButton ></SelectBox>
                </div>
                    <TextArea label="Notas" labelMode="floating" key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)}  height={144}></TextArea>
        </div>
    )
}

export { ResidentCardForm}